import React from 'react';
import { PaymentRequests } from 'components/app/erp/payment-request';

// Route-level page entry for ERP Procurement → Payment Requests (list).
const PaymentRequestPage = () => <PaymentRequests />;

export default PaymentRequestPage;
